import React from "react";
import { LineItemCategory } from "@rebuild/shared";
import { ScopeTag, getScopeTagDisplayName } from "../../MappingTool/utils/ScopeTag";

interface Props {
	lineItemCount: number;
	totalCount: number;
	sortValue: "asc" | "desc";
	onSortChange: (val: "asc" | "desc") => void;
	categoryFilter: string;
	onCategoryFilterChange: (val: string) => void;
	scopeFilter: string;
	onScopeFilterChange: (val: string) => void;
	onSearchChange: (val: string) => void;
	showRecycleBin: boolean;
	onRecycleBinClose: () => void;
	showHamburgerMenu: boolean;
	onHamburgerToggle: () => void;
	onShowRecycleBin: () => void;
	children: React.ReactNode;
}

const LineItemListControls: React.FC<Props> = ({
	lineItemCount,
	totalCount,
	sortValue,
	onSortChange,
	categoryFilter,
	onCategoryFilterChange,
	scopeFilter,
	onScopeFilterChange,
	onSearchChange,
	showRecycleBin,
	onRecycleBinClose,
	showHamburgerMenu,
	onHamburgerToggle,
	onShowRecycleBin,
	children,
}) => {
	return (
		<>
			<div className="w-full h-[60px] pt-6 border-t border-gray-300 justify-between items-center inline-flex">
				<div className="text-slate-600 text-xs font-medium font-['Hanken Grotesk'] leading-[14.40px]">
					{lineItemCount ?? 0} results shown
				</div>
				<div className="flex-col justify-start items-start inline-flex">
					<select
						className="pl-2 pr-1 py-2 bg-white rounded-lg border border-gray-200"
						value={sortValue}
						onChange={(e) => {
							onSortChange(e.target.value as "asc" | "desc");
						}}
					>
						<option value={"asc"}>Sort Alphabetically A-Z</option>
						<option value={"desc"}>Sort Alphabetically Z-A</option>
					</select>
				</div>
			</div>
			<div className="w-full mt-4 min-h-[568px] pt-6 bg-white rounded-2xl shadow border border-gray-200 flex-col justify-start items-start gap-6 inline-flex ">
				<div className="self-stretch px-6 justify-between items-center inline-flex">
					<div className="text-justify text-gray-900 text-xl font-semibold font-['Hanken Grotesk'] leading-7">
						{showRecycleBin ? (
							<span>Recycle Bin ({lineItemCount})</span>
						) : (
							<span>
								All lines ({totalCount})<br />
							</span>
						)}
					</div>

					<div className="justify-end items-center gap-5 flex">
						<div className="justify-end items-center flex">
							<div className="flex-col justify-start items-start gap-2 inline-flex">
								{showRecycleBin && (
									<div className="cursor-pointer" onClick={onRecycleBinClose}>
										<img src="/assets/ui/x-close.svg" className="w-5 h-5 relative" />
									</div>
								)}
								{!showRecycleBin && (
									<div className=" h-10 justify-start items-center gap-1.5 flex relative">
										<select
											className="px-3 py-2 bg-white rounded-lg shadow border border-gray-300 text-gray-500 text-base font-normal font-['Hanken Grotesk'] leading-normal"
											value={categoryFilter}
											onChange={(e) => onCategoryFilterChange(e.target.value)}
										>
											<option value="">All Categories</option>
											{Object.values(LineItemCategory).map((category) => (
												<option key={category} value={category}>
													{category}
												</option>
											))}
										</select>

										<select
											className="px-3 py-2 bg-white rounded-lg shadow border border-gray-300 text-gray-500 text-base font-normal font-['Hanken Grotesk'] leading-normal ml-2"
											value={scopeFilter}
											onChange={(e) => onScopeFilterChange(e.target.value)}
										>
											<option value="">All Scopes</option>
											{Object.values(ScopeTag).map((scope) => (
												<option key={scope} value={scope}>
													{getScopeTagDisplayName(scope)}
												</option>
											))}
										</select>

										<div className="self-stretch px-3.5 py-2 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex ml-2">
											<div className="grow shrink basis-0 h-6 justify-start items-center gap-2 flex">
												<img src="/assets/ui/search-lg.svg" className="w-5 h-5 relative" />
												<input
													className="p-1 w-32 text-gray-500 text-base font-normal font-['Hanken Grotesk'] leading-normal "
													placeholder="Search"
													onChange={(e) => {
														onSearchChange(e.target.value);
													}}
												/>
											</div>
										</div>

										<div className="ml-2 h-9 h-[0px] origin-top-left  border border-gray-200"></div>
										<img
											src="/assets/ui/dots-vertical.svg"
											className="w-5 h-5 relative cursor-pointer"
											onClick={onHamburgerToggle}
										/>
										{showHamburgerMenu && (
											<img
												src="/assets/ui/drop.png"
												className=" absolute cursor-pointer top-12 right-0"
												onClick={() => {
													onShowRecycleBin();
												}}
											/>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				<div className="self-stretch min-h-[480px] flex-col justify-start items-start flex ">
					{children}
				</div>
			</div>
		</>
	);
};

export default LineItemListControls;
